import Toogle from "./Toggle.component.jsx";

export default Toogle;